import { useIntl } from 'react-intl';

import { useFeatureNutrition } from 'hooks/use-feature-nutrition';
import { useLocale } from 'state/intl';
import { useFlag } from 'utils/launchdarkly';

import { CaloriesSuffix, IUseFormatCalories } from './types';

export function useFormatCalories(): IUseFormatCalories {
  const { formatMessage } = useIntl();
  const { locale } = useLocale();
  const { roundNutritionValue } = useFeatureNutrition();

  const enableFeatureNutritionIntegration = useFlag('enable-feature-nutrition-integration');

  return function formatCalories(calories: number | null, suffix: CaloriesSuffix = 'cal'): string {
    const calsString = suffix !== 'none' ? formatMessage({ id: suffix }) : '';

    if ((!calories && calories !== 0) || isNaN(calories)) {
      return '';
    }

    // New rounding for Nutrition 2.0
    if (enableFeatureNutritionIntegration) {
      return `${roundNutritionValue(calories).toLocaleString(locale)} ${calsString}`;
    }

    const calorieDisplay = Math.floor(calories).toLocaleString(locale);

    return `${calorieDisplay} ${calsString}`.trim();
  };
}
